import React from "react"
import PropTypes from "prop-types"
import bro from "../../../../static/images/bro.webp"
import pana from "../../../../static/images/pana.webp"
import cuate from "../../../../static/images/cuate.webp"
import "./card.css"

function Card({ description, image, step }) {
  return (
    <div className="wv-card-container">
      <div className="card-step">{step}</div>
      <img alt={`Step ${step}`} className="card-img" src={image} />
      <div className="card-description">{description}</div>
    </div>
  )
}

Card.propTypes = {
  description: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  step: PropTypes.number.isRequired,
}

function BookingSteps() {
  const steps = [
    {
      step: 1,
      image: bro,
      description: "You’ll select the date and time that works best for you.",
    },
    {
      step: 2,
      image: cuate,
      description: "You’ll review your appointment selection and submit.",
    },
    { step: 3, image: pana, description: "We’ll confirm your appointment!" },
  ]

  return (
    <div className="card-row">
      {steps.map((step, index) => (
        <Card key={index} {...step} />
      ))}
    </div>
  )
}

export default BookingSteps
